// frontend/src/pages/PasswordResetRequest.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import apiClient from '../api/apiClient';
import { useToast } from '../contexts/ToastContext';

const getErrorMessage = (err, fallbackMessage) => {
  const data = err?.response?.data;

  if (typeof data === 'string' && data.trim()) {
    return data;
  }

  if (typeof data?.error === 'string' && data.error.trim()) {
    return data.error;
  }

  if (typeof data?.detail === 'string' && data.detail.trim()) {
    return data.detail;
  }

  if (typeof data?.message === 'string' && data.message.trim()) {
    return data.message;
  }

  if (Array.isArray(data?.non_field_errors) && data.non_field_errors.length > 0) {
    return data.non_field_errors.join(' ');
  }

  return fallbackMessage;
};

export default function PasswordResetRequest() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await apiClient.post('/users/password-reset/', { email });
      const successMessage =
        response?.data?.message ||
        'Si el correo existe, te enviamos un enlace de recuperacion.';
      showToast(successMessage, 'success');
      navigate('/login');
    } catch (err) {
      console.error(err);
      showToast(
        getErrorMessage(err, 'No se pudo procesar la solicitud de recuperacion.'),
        'error'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-tr from-indigo-50 via-white to-pink-50 flex flex-col justify-center items-center px-6">
      <div className="text-center mb-12 max-w-lg">
        <img
          src={`${process.env.PUBLIC_URL}/images/uach_logo.png`}
          alt="UACH Logo"
          className="mx-auto mb-6 w-32 h-auto"
        />
        <h1 className="text-4xl font-extrabold text-indigo-700 mb-3">
          Sistema Integral de Adquisiciones
        </h1>
        <p className="text-lg text-indigo-600 leading-relaxed">
          Facultad de Ingenieria
          <br />
          Universidad Autonoma de Chihuahua.
        </p>
      </div>

      <form
        onSubmit={handleSubmit}
        className="bg-white p-10 rounded-3xl shadow-2xl max-w-md w-full space-y-6"
      >
        <h2 className="text-2xl font-semibold text-center text-gray-700">
          Recuperar contrasena
        </h2>

        <div>
          <label className="block mb-2 font-semibold text-gray-700">
            Correo electronico
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full px-5 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-4 focus:ring-indigo-300"
            placeholder="Ingresa tu correo institucional @uach.mx"
          />
          <p className="mt-2 text-sm text-gray-500">
            Solo se aceptan correos institucionales de la UACH.
          </p>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-gradient-to-r from-indigo-600 to-pink-500 text-white font-bold py-3 rounded-3xl shadow-lg disabled:opacity-60"
        >
          {loading ? 'Enviando...' : 'Enviar enlace'}
        </button>
      </form>
    </div>
  );
}
